import banner from './banner.png';
import introimg from './introimg.png';
import ethicalsupplier from './ethicalsuppliersimg.png';
import environmentimg from './environmentimg.png';
import econimicimg from './economicimg.png';
import responsibilityimg from './responsibilityimg.png';
import visionimg from './visionimg.png';
import valuesimg from './valuesimg.png';
import whatsetuspartimg from './whatsetusapartimg.png';
import icon1 from './icon1.png';
import icon2 from './icon2.png';
import icon3 from './icon3.png';
import fairwages from './Rectangle 64.png'
import sustainablepractices from './Rectangle 65.png'



export const ethicalpageimg ={
    banner,
    introimg,
    ethicalsupplier,
    environmentimg,
    econimicimg,
    responsibilityimg,
    visionimg,
    valuesimg,
    whatsetuspartimg,
    icon1,
    icon2,
    icon3,
    fairwages,
    sustainablepractices
}